module.exports = {
  // 活动时间线
  timeLine: {
    // 正式阶段
    launch: {
      start: new Date('2025/06/24 15:00:00 GMT+8').getTime()
    },
    // 会员倒计时
    member: {
      start: new Date('2025/09/01 15:00:00 GMT+8').getTime()
    }
  }
};